import { render, staticRenderFns } from "./ImportProductsList.vue?vue&type=template&id=18cd034c&scoped=true&"
import script from "./ImportProductsList.vue?vue&type=script&lang=js&"
export * from "./ImportProductsList.vue?vue&type=script&lang=js&"
import style0 from "./ImportProductsList.vue?vue&type=style&index=0&id=18cd034c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd034c",
  null
  
)

component.options.__file = "ImportProductsList.vue"
export default component.exports